import { isEmpty } from 'lodash';
import { View } from '../../common';
import {
  CustomerSkeleton,
  EmptyStateView,
  EndListView,
  SpinnerLoader,
} from '../../components';
import React, { MutableRefObject } from 'react';
import { SVGS } from '../../assets';
import { CustomerCard } from './customer-card';
import './customer-list.scss';
import { SelectionModeType } from '../../constants';

interface CustomersListProps {
  isloading?: boolean;
  customerData: any[];
  onCustomerSelect?: (customer: any) => void;
  onCheckboxToggle?: (customer: any) => void;
  selectedItem?: any;
  lastItemRef: MutableRefObject<HTMLDivElement | null>;
  isEndOfList?: boolean;
  showSearch?: boolean;
  searchKey?: string;
  selectionMode?: SelectionModeType;
  showCallBtn?: boolean;
  needArrowRight?: boolean;
  idToCompare?: string;
  titleKey?: string;
  fallbackKeys?: string[];
}

export const CustomersList: React.FC<CustomersListProps> = ({
  isloading = false,
  customerData = [],
  onCustomerSelect,
  onCheckboxToggle,
  selectedItem,
  lastItemRef,
  isEndOfList = false,
  showSearch = false,
  searchKey = '',
  selectionMode,
  showCallBtn = false,
  needArrowRight = true,
  idToCompare = 'inviteId',
  titleKey = 'companyName',
  fallbackKeys = ['name', 'supplierName'],
}) => {
  return isloading ? (
    <CustomerSkeleton className="customer-list-skeleton-view" />
  ) : (
    <View className="customer-list-container">
      {isEmpty(customerData) ? (
        <EmptyStateView
          imageSrc={SVGS.NoCustomer}
          message="No Such Customers Found"
        />
      ) : (
        <>
          {showSearch && searchKey?.length > 0 && (
            <span className="customer-list-container--search-results font-regular">
              {customerData?.length} result
              {customerData?.length > 1 ? 's' : ''} found for "
              <span className="font-semibold">{searchKey}</span>"
            </span>
          )}
          {customerData.map((item, index) => (
            <CustomerCard
              key={item.id}
              customer={item}
              onCheckboxToggle={onCheckboxToggle}
              onCustomerSelect={onCustomerSelect}
              isFirst={index === 0}
              isLast={index === customerData.length - 1}
              selectionMode={selectionMode}
              selectedItem={selectedItem?.id === item.id}
              titleKey={titleKey}
              fallbackKeys={fallbackKeys}
              showCallBtn={showCallBtn}
              needArrowRight={needArrowRight}
              idToCompare={idToCompare}
            />
          ))}
          <div ref={lastItemRef} className="customer-last-item" />
          {!isEndOfList && <SpinnerLoader />}
          {isEndOfList && <EndListView />}
        </>
      )}
    </View>
  );
};
